import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { tap } from 'rxjs/operators';
import { Api } from 'src/app/shared/constants/api';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import * as _ from 'underscore';
import { EquipmentSizeFormComponent } from '../equipment-size-form/equipment-size-form.component';
import { IEquipmentSize, IEquipmentSizeCriteria } from '../equipment-size.interface';
import { Message } from 'src/app/shared/constants/message';

@Component({
    selector: 'app-equipment-size-view',
    templateUrl: './equipment-size-view.component.html',
    styleUrls: ['./equipment-size-view.component.less'],
    standalone: false
})
export class EquipmentSizeViewComponent implements OnInit {

  equipmentSizeForm: FormGroup;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  pageSizeOptions: Array<number> = this.utilityService.getPageSizeOptions();
  totalEquipmentSizeRecords:number;
  groupColumns = ['size', 'noOfTeu', 'action'];
  criteria: IEquipmentSizeCriteria = {};
  permissions = [];
	addPermission : boolean = false;
	editPermission : boolean = false;
	viewPermission : boolean = false;
  public dataSource = new MatTableDataSource<IEquipmentSize>();

  constructor(private service: DataService,
              private formBuiler: FormBuilder, private dialog: MatDialog,
              private utilityService: UtilityService, private permissionService:PermissionService) { }

  ngOnInit(): void {
    this.checkAllPermission();
    this.initializeForm();
  }

  ngAfterViewInit() {
    this.dataSource.sort=this.sort;
    this.dataSource.paginator=this.paginator;
		this.paginator?.page?.pipe(tap(() => this.getEquipmentSizes())).subscribe();
		this.getEquipmentSizes();
	}

  private initializeForm() {
    this.equipmentSizeForm = this.formBuiler.group({
      size: [null],
      noOfTeu: [null]
    });
  }

  private getEquipmentSizes(resetPageIndex: boolean =false){
    if (resetPageIndex) {
      this.paginator.pageIndex = 0;
    }
    this.criteria.page=this.paginator?.pageIndex;
    this.criteria.size=this.paginator?.pageSize;
    if(this.viewPermission){
        this.service.get(Api.EQUIPMENT_SIZE, this.criteria).subscribe(res => {
        this.dataSource = res.contents;
        this.totalEquipmentSizeRecords = res.totalRecords;
        if (this.paginator.pageIndex >= Math.ceil(res.totalRecords / this.paginator.pageSize)) {
          this.paginator.pageIndex = 0;
        }
      });
    } else
        this.utilityService.notifier(Message.VIEW_PERMISSION_WARNING,"warning");
  }

  sortData(event: { active: string; direction: string; }) {
      this.criteria.sort = [event.active, event.direction];
      this.getEquipmentSizes(true);
	}

  openForm(row?: any): void {
    if(!this.addPermission && !row)
      return this.utilityService.notifier(Message.ADD_PERMISSION_WARNING,"warning");
    if(!this.editPermission && row)
      return this.utilityService.notifier(Message.EDIT_PERMISSION_WARNING,"warning");
      const dailogRef = this.dialog.open(EquipmentSizeFormComponent, { data: row });
      dailogRef.afterClosed().subscribe(() => this.getEquipmentSizes());
  }

  public checkAllPermission(){
      const permissionCodes=[PermissionKey.EQUIPMENT_SIZE_MODULE_ADD_PERMISSION,PermissionKey.EQUIPMENT_SIZE_MODULE_DELETE_PERMISSION,
      PermissionKey.EQUIPMENT_SIZE_MODULE_EDIT_PERMISSION,PermissionKey.EQUIPMENT_SIZE_MODULE_VIEW_PERMISSION];
      const permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.EQUIPMENT_SIZE_MODULE);
      this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.EQUIPMENT_SIZE_MODULE_ADD_PERMISSION})?.show?true:false;
      this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.EQUIPMENT_SIZE_MODULE_EDIT_PERMISSION})?.show?true:false;
      this.viewPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.EQUIPMENT_SIZE_MODULE_VIEW_PERMISSION})?.show?true:false; 
  }

}
